import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m20,18.8H4c-1.5,0-2.8-1.2-2.8-2.8v-8c0-1.5,1.2-2.8,2.8-2.8h16c1.5,0,2.8,1.2,2.8,2.8v8c0,1.5-1.3,2.8-2.8,2.8ZM4,6.8c-.7,0-1.2.5-1.2,1.2v8c0,.7.6,1.2,1.2,1.2h16c.7,0,1.2-.6,1.2-1.2v-8c0-.7-.6-1.2-1.2-1.2H4Z"
          stroke-width="0"
        />
        <path
          d="m16.2,13.3c-.1.1-.3.1-.4,0l-2.3-2.3c-.2-.2-.1-.5.2-.5h4.6c.3,0,.4.3.2.5l-2.3,2.3Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
